var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeptUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1735869802025,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 1996,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M886.76 161.74c-2.12 0-4.22 0.1-6.3 0.26a80.26 80.26 0 0 0-148.8 2.36 80.22 80.22 0 1 0-6.36 156.52 80.24 80.24 0 0 0 143.66-0.76 80.2 80.2 0 1 0 17.82-158.4z",
    fill: "#FFD43B",
    "p-id": 1997
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M675 435m-48 0a48 48 0 1 0 96 0 48 48 0 1 0-96 0Z",
    fill: "#FFD43B",
    "p-id": 1998
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M630.42 707.3c-49.2-20.56-130.7-54.58-165.26-68.9a87.58 87.58 0 0 0-33.54-6.68h-93.24a87.58 87.58 0 0 0-33.54 6.68c-34.56 14.32-116 48.34-165.26 68.9a87.46 87.46 0 0 0-50.84 58.24L57.78 882A23.06 23.06 0 0 0 80 911h610a23.06 23.06 0 0 0 22.22-29l-30.94-116.5a87.46 87.46 0 0 0-50.86-58.2z",
    fill: "#495057",
    "p-id": 1999
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M287.96 623.06h204.34l-95.86 354.56h-16.96l-91.52-354.56z",
    fill: "#FFFFFF",
    "p-id": 2000
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M385 765.04h12.46a2.36 2.36 0 0 0 2-1.04l11.9-17.44a2.36 2.36 0 0 0-0.28-3l-22.68-22.48a4.74 4.74 0 0 0-6.66 0l-22.68 22.5a2.36 2.36 0 0 0-0.28 3l11.9 17.44a2.36 2.36 0 0 0 2 1.04zM385 775.66h-9.8a4.74 4.74 0 0 0-4.72 4.38l-12.48 170.8a4.74 4.74 0 0 0 4.72 5.08h44.64a4.74 4.74 0 0 0 4.72-5.08L399.52 780a4.74 4.74 0 0 0-4.72-4.38z",
    fill: "#FF6B6B",
    "p-id": 2001
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M254.42 614.18v101.64l35.52 26-24.86 31.9 95.86 169.02 12.62-8.28L301.76 600l-47.34 14.18zM515.58 614.18v101.64l-35.52 26 24.86 31.9-95.86 169.02-12.62-8.28L468.24 600l47.34 14.18z",
    fill: "#868E96",
    "p-id": 2002
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M299.18 612.14h171.64l-85.82 107.58-85.82-107.58zM233.04 412h110.16v79.6h-110.16a39.88 39.88 0 0 1-40-39.86 39.84 39.84 0 0 1 40-39.74zM533.86 412h-110.96v79.6h110.96a39.88 39.88 0 0 0 40-39.86 39.84 39.84 0 0 0-40-39.74z",
    fill: "#F9BF87",
    "p-id": 2003
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M264.96 269.14h78v155.42h-112a29.54 29.54 0 0 1-29.54-29.54v-62.44a63.46 63.46 0 0 1 63.54-63.44zM538.68 424.54h-112v-155.42h78a63.46 63.46 0 0 1 63.46 63.46v62.42a29.54 29.54 0 0 1-29.46 29.54z",
    fill: "#495057",
    "p-id": 2004
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M251.74 348.4v-40.3a101.12 101.12 0 0 1 101.12-101.12h167.32a40.3 40.3 0 0 1 40.22 40.3 101.12 101.12 0 0 1-101.12 101.12H251.74z",
    fill: "#495057",
    "p-id": 2005
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M340.84 337.28h88.32a109.72 109.72 0 0 1 109.72 109.72v43.86a153.78 153.78 0 0 1-153.78 153.78h-0.2a153.78 153.78 0 0 1-153.78-153.78v-43.88a109.72 109.72 0 0 1 109.72-109.72z",
    fill: "#FFCC90",
    "p-id": 2006
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M318.76 503.84a50 50 0 1 1 50-50 50 50 0 0 1-50 50z m0-87.34a37.38 37.38 0 1 0 37.44 37.38 37.44 37.44 0 0 0-37.44-37.38zM451.86 503.84a50 50 0 1 1 50-50 50 50 0 0 1-50 50z m0-87.34a37.38 37.38 0 1 0 37.44 37.38 37.44 37.44 0 0 0-37.44-37.38z",
    fill: "#495057",
    "p-id": 2007
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M406.4 451.02c-24-10.76-40.72-0.82-41.42-0.4l-6.7-10.62c0.92-0.58 22.9-14 53.28-0.42z",
    fill: "#495057",
    "p-id": 2008
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M306.36 453.88a14.18 14.16 0 1 0 28.36 0 14.18 14.16 0 1 0-28.36 0Z",
    fill: "#495057",
    "p-id": 2009
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M432.94 453.88a14.18 14.16 0 1 0 28.36 0 14.18 14.16 0 1 0-28.36 0Z",
    fill: "#495057",
    "p-id": 2010
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M385 593.62A60 60 0 0 1 334.34 566a6 6 0 0 1 10-6.5 48.22 48.22 0 0 0 81.12 0 6 6 0 0 1 10 6.5 60 60 0 0 1-50.46 27.62zM787.26 259.52v-0.76q0.6-11.42 5.84-17.88a68 68 0 0 1 11.28-11.12q6-4.68 11.08-9.24a15.56 15.56 0 0 0 5.04-12.16 17.76 17.76 0 0 0-5.72-13.42 21.34 21.34 0 0 0-15.26-5.42q-10.3 0-15.64 5.04a25.76 25.76 0 0 0-7.3 11.86 8.18 8.18 0 0 1-2.82 4.48 9.04 9.04 0 0 1-5.72 1.62h-5.06a7.14 7.14 0 0 1-5.54-2 6.4 6.4 0 0 1-1.08-5.86A41.16 41.16 0 0 1 769.08 182q10.4-10 30.42-10 18.68 0 30.54 9.34t11.84 25.74q0 11.44-5.26 18a71.24 71.24 0 0 1-11.46 11.34q-6.22 4.86-11.66 9.74a18.76 18.76 0 0 0-6 13.26v1.14a6.92 6.92 0 0 1-2 4.88 7.8 7.8 0 0 1-5.44 1.62h-5.64a7.7 7.7 0 0 1-5.74-1.88 6.72 6.72 0 0 1-1.42-5.66z m-1.74 37.68v-5.84a8.6 8.6 0 0 1 2.32-6.5 9.2 9.2 0 0 1 6.62-2.24h5.44a7.84 7.84 0 0 1 8.74 8.74v5.84a7.82 7.82 0 0 1-8.74 8.74h-5.44a9.2 9.2 0 0 1-6.62-2.22 8.62 8.62 0 0 1-2.32-6.52z",
    fill: "#495057",
    "p-id": 2011
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeptUser);
export default __webpack_public_path__ + "static/media/deptUser.83386869e6f3d126482ec8ed7f7d4ce6.svg";
export { ForwardRef as ReactComponent };